import ConditionalWrap from 'conditional-wrap';
import React from 'react';
import LazyLoad from 'react-lazyload';

import { StyledImage, StyledWrapper } from './Avatar.styles';
import { IAvatarProps } from './Avatar.types';

const Avatar = ({
  alt,
  lazyLoad = false,
  size = '100%',
  src,
}: IAvatarProps): JSX.Element => {
  return (
    <StyledWrapper size={size}>
      <ConditionalWrap
        condition={!!lazyLoad}
        wrap={children => (
          <>
            <LazyLoad offset={100} once>
              {children}
            </LazyLoad>
            <noscript>{children}</noscript>
          </>
        )}
      >
        <StyledImage alt={alt} src={src} />
      </ConditionalWrap>
    </StyledWrapper>
  );
};

export default Avatar;
